import { Aggregates } from "hfapi";

class RecommendMail extends Aggregates.RecommendMail {
}

export default RecommendMail;
